
<template>
  <div calss="mainDialog">
    <!-- 弹窗treeyhj -->
    <el-dialog
      :title="dialogTitle"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="isShow"
      :before-close="handleClose"
      width="400px"
    >
      <div class="dialog-tree">
        <!-- <div class="dialog-tree__search" v-if="isSerch">
          <el-input
            placeholder="请输入搜索关键字"
            prefix-icon="el-icon-search"
            v-model="searchText"
            clearable
          >
          </el-input>
        </div> -->
        <div class="dialog-tree__scroller-area" :key="key">
          <template v-if="menusData && menusData.length" prop="buildingNames">
            <el-scrollbar class="dialog-tree__scroller">
              <el-tree
                class="dialog-tree__tree"
                ref="tree"
                :data="menusData"
                accordion
                :current-node-key="currentNodeId"
                @node-click="handleNodeClick"
                :props="menusDataProps"
                :check-on-click-node="checkOnClickNode"
                :highlight-current="highlightCurrent"
                :default-expand-all="expandAll"
                :show-checkbox="showCheckbox"
                :node-key="buildingCode"
                :filter-node-method="filterNode"
              >
                <span class="custom-tree-node" slot-scope="{ node }">
                  <i class="el-icon-document"></i>
                  <span class="node-title">{{ node.label }}</span>
                </span>
              </el-tree>
            </el-scrollbar>
          </template>
          <div class="no-data-text" v-else>
            <div>
              <img src="@/common/assets/images/empty.svg" class="no-data_img" />
            </div>
            <div>暂无数据</div>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        v-if="menusData && menusData.length"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- <el-button type="text"
               @click="dialogVisible = true">点击打开 Dialog</el-button> -->

    <!-- 页面使用Tree 区域树  -->
    <div class="dialog-tree nodialog" v-if="isPageTree">
      <div class="dialog-tree__search" v-if="isSerch">
        <el-input
          placeholder="请输入搜索关键字"
          v-model="searchText"
          prefix-icon="el-icon-search"
          clearable
        >
        </el-input>
      </div>
      <div class="dialog-tree__scroller-area" :key="key">
        <template v-if="menusData && menusData.length">
          <el-scrollbar class="dialog-tree__scroller">
            <el-tree
              class="dialog-tree__tree"
              ref="tree"
              :data="menusData"
              accordion
              :current-node-key="currentNodeId"
              @node-click="handleNodeClick"
              :props="menusDataProps"
              @check-change="handleCheckChange"
              :check-on-click-node="checkOnClickNode"
              :highlight-current="highlightCurrent"
              :default-expand-all="expandAll"
              :show-checkbox="showCheckbox"
              :node-key="buildingCode"
              :filter-node-method="filterNode"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <i class="el-icon-document"></i>
                <span style="margin-left: 3px">{{ node.label }}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </template>
        <div class="no-data-text" v-else>
          <div>
            <img src="@/common/assets/images/empty.svg" class="no-data_img" />
          </div>
          <div>暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    searchText(val) {
      this.$refs.tree.filter(val);
    },
  },
  props: {
    isPageTree: {
      // 是否使用页面tree
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isSerch: {
      // 是否使用页面tree-serch
      type: Boolean,
      default: () => {
        return true;
      },
    },
    isRequired: {
      // 是否必选
      type: Boolean,
      default: () => {
        return true;
      },
    },
    showCheckbox: {
      // 是否多选
      type: Boolean,
      default: () => {
        return true;
      },
    },
    expandAll: {
      type: Boolean,
      // 默认展开所有。
      default: () => {
        return true;
      },
    },
    dialogTitle: {
      // 弹窗标题
      type: String,
      default: () => {
        return "选择楼栋楼层";
      },
    },
  },
  data() {
    return {
      key: 0,
      data: [],
      handleClickData: [], //单选时的选中数据
      menusData: [],
      menusDataProps: {
        children: "subBuildingList",
        label: "buildingName",
        id: "buildingCode",
      },
      buildingCode: "buildingCode",
      currentNodeId: "",
      highlightCurrent: true, // 选中高亮。
      checkOnClickNode: true, // 默认点击选中。
      nodeKey: "buildingCode", //tree 唯一节点
      // accordion。是否每次只打开一个同级树节点展开
      isShow: false, //带弹窗tree
      searchText: "",
    };
  },
  mounted() {
    this.getTree();
  },
  methods: {
    getTree() {
      //获取树结构
      this.$fetch("/cms/building/queryBuildingTree.json").then((res) => {
        if (res && res.success) {
          this.menusData = [...res.returnObj];
          // this.$nextTick(() => {
          //   this.$refs["tree"].setCheckedKeys(this.data || []);
          // });
          console.log(res);
        } else {
          this.$message.error("获取数据失败,请稍后再试");
        }
      });
    },
    handleNodeClick(data, node) {
      console.log(data, "data");
      this.treeClickCount++;
      if (this.treeClickCount >= 2) {
        return;
      }
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          this.treeClickCount = 0;
          this.handleClickData = [data];
          this.$emit("handleClick", data);
          // console.log('单击事件,可在此处理对应逻辑')
        } else if (this.treeClickCount > 1) {
          this.treeClickCount = 0;
          this.$emit("handleDblClickDbl", data);
          // console.log('双击事件,可在此处理对应逻辑')
        }
      }, 300);
    },
    handleCheckChange(data, isCheck) {
      this.$emit("handleCheckChange", data, isCheck);
      let checkedkeysArr = [...this.$refs.tree.getCheckedKeys()];
      this.$emit("checkedKeys", checkedkeysArr);
    },
    openDialog(data = []) {
      // 展开树并回显
      this.isShow = true;

      this.key += 1;
      this.data = data;
      console.log(this.data);
      console.log(this.showType);
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.data || []);
      });
      this.currentNodeId = data.length > 0 ? data[0] : "";
    },
    setChooseKeys(data = []) {
      this.$nextTick(() => {
        this.$refs["tree"].setCheckedKeys(data || []);
      });
    },
    handleSubmit() {
      // 单选/多选
      let checkedData = this.showCheckbox
        ? [...this.$refs.tree.getCheckedNodes()]
        : [...this.handleClickData];
      if (checkedData.length === 0 && this.isRequired) {
        this.$message.warning("请" + this.dialogTitle + "后提交数据");
      } else {
        // 向父组件传递选中数组checkedData
        console.log(checkedData, "checked");
        this.$emit("saveChecked", checkedData);

        this.handleClose();
      }
    },
    handleClose() {
      this.$refs["tree"].setCheckedKeys([]);
      this.isShow = false;
      this.searchText = "";
    },
    filterNode(value, data) {
      if (!value) return true;
      return (data.buildingNames || "").indexOf(value) !== -1;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.dialog-tree {
  height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &__search {
    margin-bottom: 10px;
  }
  &__scroller-area {
    flex: 1;
    overflow: hidden;
  }
  &__scroller {
    height: 100%;
    width: 100%;
  }
  .node-title {
    margin-left: 5px;
    // @include set_theme_color(color, main-theme-color);
  }
  /deep/.el-tree-node__content {
    &:hover {
      @include set_theme_color(background-color, main-theme-color);
    }
  }
  /deep/.el-tree {
    @include set_theme_color(background-color, top-menu-bg-color);
  }
  /deep/.el-scrollbar__wrap {
    padding: 15px 0;
    @include set_theme_color(background-color, top-menu-bg-color);
  }

  .no-data-text {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @include set_theme_color(color, font-disabled-color);
    .no-data_img {
      margin-bottom: 10px;
    }
  }
}
</style>



